export default "__VITE_ASSET__aJysUrOY__"